<template>
  <div v-html="apply">{{apply}}</div>
</template>

<script>
export default {
  name: "zhifubaozf",
  data() {
    return {
      apply: ""
    };
  },
  created() {
    let form = this.$route.query.htmls;
    this.apply = form;
    this.$nextTick(() => {
      document.forms[0].submit();
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/zhifubaozf.vue